class ProductPageDrawer extends HTMLElement {
  constructor() {
    super();

    this.activeElement = null;

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });
  }

  connectedCallback() {
    this.bindTriggers();
    this.bindCloseHandlers();
  }

  bindCloseHandlers() {
    if (this.dataset.closeHandlersBound === 'true') return;

    this.dataset.closeHandlersBound = 'true';

    this.querySelector('[data-drawer-close]')?.addEventListener('click', () => this.close());

    this.addEventListener('click', (event) => {
      if (!this.classList.contains('active')) return;

      const inner = this.querySelector('.product-info-drawer__inner');
      if (inner && !inner.contains(event.target)) {
        this.close();
      }
    });
  }

  bindTriggers() {
    const drawerId = this.id;
    if (!drawerId) return;

    document
      .querySelectorAll(`[data-page-drawer-trigger="${drawerId}"]:not([data-drawer-bound])`)
      .forEach((trigger) => {
        trigger.dataset.drawerBound = 'true';
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(trigger);
        });
      });
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.querySelector('.product-info-drawer__close') || this.querySelector('.drawer__inner');
        trapFocus(this.querySelector('.drawer__inner'), focusElement);
      },
      { once: true }
    );

    lockBodyScroll();

    const scrollContainer = this.querySelector('.product-info-drawer__content');
    if (scrollContainer) scrollContainer.scrollTop = 0;

    if (typeof window.initProductSizeGuides === 'function') {
      window.initProductSizeGuides(this);
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    unlockBodyScroll();
  }
}

if (!customElements.get('product-page-drawer')) {
  customElements.define('product-page-drawer', ProductPageDrawer);
}
